module.exports = __webpack_public_path__ + "img/ep-7-dosis.c18efbb8.jpg";